module.exports = __webpack_public_path__ + "static/media/fact.5aaff679.png";